import { render, staticRenderFns } from "./DashboardPartnerProgramCard.vue?vue&type=template&id=498936f1&scoped=true"
import script from "./DashboardPartnerProgramCard.vue?vue&type=script&lang=ts"
export * from "./DashboardPartnerProgramCard.vue?vue&type=script&lang=ts"
import style0 from "./DashboardPartnerProgramCard.vue?vue&type=style&index=0&id=498936f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498936f1",
  null
  
)

export default component.exports